// What each kind of gap on a partial roof warranty grade reads as, on every page that shows
// one (docs/Y2026-Q4/design-partially-received.md).
import type { GapKind } from "../api/hooks/useAmazonOverview";

/** Must cover ready_checks.GAP_KINDS. */
export const GAP_LABEL: Record<GapKind, string> = {
  not_signed: "Not signed",
  not_dated: "Not dated",
  terms_missing: "Terms not attached",
  expired: "Expired",
  other_address: "Another building's address",
  part_of_roof: "Covers only part of the roof",
  pages_missing: "Pages missing",
  other: "Other gap",
};
